import compose from "recompose/compose";
import withProps from "recompose/withProps";
import { withCrop } from "@xem/entity";
import { withQrOptions } from "@xem/qr-client-react/config";
import withQrUpload from "@xem/qr-common/classes/withQrUpload";
import withMediaDeleting from "@xem/media-common/classes/withMediaDeleting";
import withMedias from "@xem/media-common/classes/withMedias";
import Medias from "@xem/media-common/classes/Medias";

import onUpload from '@xem/entity/classes/onUpload';
import QrValueMap from "@xem/qr-common/classes/QrValueMap";
import SvgRender from "@gqlapp/qrcode/Render";
import {hexToRgbTo} from "@gqlapp/qrcode";

const svgHead = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n " +
	"<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 20010904//EN\" \"http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd\">\n"

/**
 *
 * @param text
 * @param svg
 * @param options
 */
export async function getBlob(text: string, svg: any, options?: any) {
	if(options?.dbg){ delete svg.background; }

	if(options?.dic){
		delete svg.icon;
		let color = svg?.color;
		const $rgb = hexToRgbTo(color);
		let contrastColor = $rgb < 180 ? '#ffffff' : '#000000';
		svg = Object.assign({}, svg, { contrastColor, size: 30 });
	}

	let values = QrValueMap(svg);
	let dataSVG = SvgRender({ text, input: values, fontPath: 'https://cdn.xem.link/public/static/fonts.css'});
	let htmlContent = [svgHead + dataSVG];
	return new Blob(htmlContent, { type: "image/svg+xml"});
}

export function endCompose(){
	return compose(
		withProps(({ uploadFile })=> ({
			onUpload: onUpload(uploadFile, { errorMsg: 'qr:update.errorMsg'.t() }),
		})),
		withProps(({ values, onActions, onUpload, medias, setFieldValue, mediaDelete, data_text })=> ({
			items: medias.items || [],
			callback: async ({ file }) =>{
				return onUpload({ file })
					.then(func(medias.refetch))
					.catch(errorCatch)
			},
			handleDelete: function (id: number) {
				return function handleDelete(){
					return mediaDelete(id)
						.then(func(medias.refetch))
						.catch(errorCatch)
				}
			},
			handleSettings: async function  handleSettings() {
				let data = Object.assign({}, values);
				let imageBg = data.icon.src;
				let blob_1 = await getBlob(data_text, data, { dbg: true });
				let blob_2 = await getBlob(data_text, data, { dbg: true, dic: true });

				function onChange(data: any, { onClose }){
					if(data){
						let color = values?.color;
						const $rgb = hexToRgbTo(color);
						let contrastColor = $rgb < 180 ? '#ffffff' : '#000000';

						setFieldValue('background', data);
						setFieldValue('contrastColor', contrastColor)
						setFieldValue('size', 30)
					}
					func(onClose)();
				}

				let bg = values?.background;
				let v = Object.assign({}, values?.background, { imageIsBg: (bg?.x && bg?.y && bg?.zoom)  })

				func(onActions?.bgSettingsQR)({ blob_1, blob_2, imageBg, onChange, values: v });
			}
		})),
		withProps(({ values, data_text })=> ({ data_text: data_text || values?.data_text })),
	)
}

export default compose(
	withCrop,
	withQrUpload,
	withMediaDeleting,
	withMedias(({})=>({ skip: !!__SERVER__, medias: Medias.instanse(), pageSize: 50, filter:{ type: 'qr' }})),
	withQrOptions
);